import { siteConstants } from "../constants/siteConstants";

const initialState = {
  sending: false,
  siteResponse: {},
  error: "",
  fetching: "",
  messageResponse: {},
  emailResponse: {},
  siteList: {},
  sitePaidList: {},
  sitepaidData: [],
  siteData: [],
  siteDataById: {},
  siteEditResponse: {},
  deleteSiteStatus: {},
  siteStatusResponse: {},
  sitenameResponse: {},
  sitedomainResponse: {},
  citygeolocation: {},
  responseData: {},
  loading: false,
  domainStatus: {},
  domainList: {},
  ssl: {},
};

export default function siteReducer(state = initialState, action) {
  switch (action.type) {
    case siteConstants.GET_CUSTOMER_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case siteConstants.GET_CUSTOMER_DATA_SUCCESS:
      return { ...state, searchData: action.responseData.data, loading: false };
    case siteConstants.GET_CUSTOMER_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case siteConstants.GET_DASHBOARD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case siteConstants.GET_DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        dashboardData: action.responseData.data,
        loading: false,
      };
    case siteConstants.GET_PAIDDASHBOARD_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

      case siteConstants.GET_PAIDDASHBOARD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case siteConstants.GET_PAIDDASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        dashboardpaidData: action.responseData.data,
        loading: false,
      };
    case siteConstants.GET_DASHBOARD_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case siteConstants.ADD_SITE_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.ADD_SITE_SUCCESS:
      return {
        ...state,
        siteResponse: action.sitedata,
      };
    case siteConstants.ADD_SITE_FAILURE:
      return {
        error: action.error,
      };
    case siteConstants.CHECK_USERNAME_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.CHECK_USERNAME_SUCCESS:
      return {
        ...state,
        messageResponse: action.message,
      };
    case siteConstants.CHECK_USERNAME_FAILURE:
      return {
        error: action.error,
      };
    case siteConstants.CHECK_USER_EMAIL_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.CHECK_USER_EMAIL_SUCCESS:
      return {
        ...state,
        emailResponse: action.emailResponse,
      };
    case siteConstants.CHECK_USER_EMAIL_FAILURE:
      return {
        error: action.error,
      };
    case siteConstants.VIEW_SITELIST_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.VIEW_SITELIST_SUCCESS:
      return {
        ...state,
        error: "",
        siteList: action.sitelist.data,
        siteData: action.sitelist.data.data,
        siteEditResponse: {},
        siteResponse: {},
      };
    case siteConstants.VIEW_SITELIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.VIEW_SITEPAIDLIST_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.VIEW_SITEPAIDLIST_SUCCESS:
      return {
        ...state,
        error: "",
        sitePaidList: action.sitelist.data,
        sitepaidData: action.sitelist.data.data,
        siteEditResponse: {},
        siteResponse: {},
      };
    case siteConstants.VIEW_SITEPAIDLIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.VIEW_SITEDATABYID_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.VIEW_SITEDATABYID_SUCCESS:
      return {
        ...state,
        siteDataById: action.sitedatabyId.data,
        error: "",
      };
    case siteConstants.VIEW_SITEDATABYID_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.UPDATE_SITE_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.UPDATE_SITE_SUCCESS:
      return {
        ...state,
        siteEditResponse: action.updatesite,
      };
    case siteConstants.UPDATE_SITE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.UPDATE_SITE_STATUS_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.UPDATE_SITE_STATUS_SUCCESS:
      return {
        ...state,
        siteStatusResponse: action.updatestatus,
      };
    case siteConstants.UPDATE_SITE_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.DELETE_SITE_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.DELETE_SITE_SUCCESS:
      return {
        ...state,
        deleteSiteStatus: action.site,
      };
    case siteConstants.DELETE_SITE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.CHECK_SITENAME_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.CHECK_SITENAME_SUCCESS:
      return {
        ...state,
        sitenameResponse: action.message,
      };
    case siteConstants.CHECK_SITENAME_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.CHECK_SITEDOMAIN_REQUEST:
      return {
        sending: true,
      };
    case siteConstants.CHECK_SITEDOMAIN_SUCCESS:
      return {
        ...state,
        sitedomainResponse: action.siteDomainProps,
        error: "",
      };
    case siteConstants.CHECK_SITEDOMAIN_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case siteConstants.GET_CITY_GEOLOCATION_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case siteConstants.GET_CITY_GEOLOCATION_SUCCESS:
      return {
        ...state,
        citygeolocation: action.data,
      };
    case siteConstants.GET_CITY_GEOLOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.SEND_SUBDOMAIN_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case siteConstants.SEND_SUBDOMAIN_SUCCESS:
      return {
        ...state,
        domainStatus: action.responseData,
      };
    case siteConstants.SEND_SUBDOMAIN_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.SEND_SUBDOMAINLIST_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case siteConstants.SEND_SUBDOMAINLIST_SUCCESS:
      return {
        ...state,
        domainList: action.responseData,
      };
    case siteConstants.SEND_SUBDOMAINLIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case siteConstants.SEND_SSL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case siteConstants.SEND_SSL_SUCCESS:
      return {
        ...state,
        ssl: action.responseData,
      };
    case siteConstants.SEND_SSL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/siteReducer.js